import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { formatPercent } from "../format/formatPercent";
import type { FindingOf } from "../model/Finding";

// Как противостоять: чем убийца бил чаще всего.
const COUNTER = msg({
  id: "finding.killed_by_hero.counter",
  message:
    "{kind, select, melee {{share} of their damage was melee: parry their heavy hits and keep your distance.} spirit {{share} of their damage was spirit: spirit resistance items help.} other {{share} of their damage was bullets: bullet resistance items help.}}",
});

const PARRIES = msg({
  id: "finding.killed_by_hero.parries",
  message: "Successful parries this match: {success} of {attempts}.",
});

type KillerCounterProps = {
  finding: FindingOf<"killed_by_hero">;
  className?: string;
};

// Совет против героя, который убивает снова и снова: по основному типу его урона, для ближнего
// боя — ещё и парирования игрока. Данных об источниках урона нет — совета нет.
export const KillerCounter = ({ finding, className }: KillerCounterProps) => {
  const { i18n } = useLingui();
  const { melee_share: melee, spirit_share: spirit, bullet_share: bullet } = finding.params;
  const [kind, share] = (
    [
      ["melee", melee],
      ["spirit", spirit],
      ["bullet", bullet],
    ] as const
  ).reduce((best, entry) => (entry[1] > best[1] ? entry : best));
  if (share <= 0) {
    return null;
  }
  const { parry_success: success, parry_attempts: attempts } = finding.params;
  return (
    <p className={className}>
      {i18n._({ ...COUNTER, values: { kind, share: formatPercent(share, i18n.locale) } })}
      {kind === "melee" && attempts != null && attempts > 0 && (
        <> {i18n._({ ...PARRIES, values: { success: success ?? 0, attempts } })}</>
      )}
    </p>
  );
};
